import { usePosterContext } from "../../context/poster-context";
import Preview1 from "./components/preview-1/preview-1";
import Preview2 from "./components/preview-2/preview-2";
import Preview3 from "./components/preview-3/preview-3";
import { PreviewWrapper } from "./styles/preview.style";

const Preview = () => {
  const { selectedTemplate } = usePosterContext();
  return (
    <PreviewWrapper>
      {!selectedTemplate && <span>포스터 템플릿을 선택해주세요.</span>}
      {selectedTemplate === 1 && <Preview1 />}
      {selectedTemplate === 2 && <Preview2 />}
      {selectedTemplate === 3 && <Preview3 />}
    </PreviewWrapper>
  );
};

export default Preview;
